import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '../api';
import { PrintReceiptDto } from '../../generated-api/models/PrintReceiptDto';
import { EmailReceiptDto } from '../../generated-api/models/EmailReceiptDto';
import { ReceiptSuccessDto, ErrorMessage, PrintReceiptRequest } from '../../generated-api';

export const useSendEmailReceipt = (reference: string) => {
  const apiClient = useApiClient();

  const sendEmail = async (emailReceiptDto: EmailReceiptDto) =>
    apiClient.ReceiptControllerApi.emailReceipt(
      { reference, emailReceiptDto },
      {
        headers: { 'Content-type': 'application/json' },
      }
    );

  return useMutation<ReceiptSuccessDto, ErrorMessage, EmailReceiptDto>({ mutationFn: sendEmail });
};

export const useMutatePrintReceipt = () => {
  const apiClient = useApiClient();

  const printReceipt = async ({
    reference,
    printReceiptDto,
  }: {
    reference: string;
    printReceiptDto: PrintReceiptDto;
  }) =>
    apiClient.ReceiptControllerApi.printReceipt(
      { reference, printReceiptDto },
      {
        headers: { 'Content-type': 'application/json' },
      }
    );

  return useMutation<ReceiptSuccessDto, ErrorMessage, PrintReceiptRequest>({ mutationFn: printReceipt });
};
